import React from "react";
import "./cookiepolicy.css";

const CookiePolicy = () => (
  <div className="cookie-policy-container">
    <h1>Cookie Policy</h1>
    <h2>What Are Cookies?</h2>
    <p>
      Cookies are small text files that are placed on your device by websites that you visit. They are widely used to make websites work, or work more efficiently, as well as to provide information to the owners of the site.
    </p>
    <h2>How We Use Cookies</h2>
    <p>
      Cysigil Network Pvt Ltd. uses cookies to enhance your experience on our website, analyze site usage, and assist in our marketing efforts. Cookies help us understand how you interact with our site so we can improve your experience.
    </p>
    <h2>Types of Cookies We Use</h2>
    <ul>
      <li><strong>Essential Cookies:</strong> These cookies are necessary for the website to function and cannot be switched off in our systems.</li>
      <li><strong>Performance Cookies:</strong> These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.</li>
      <li><strong>Functional Cookies:</strong> These cookies enable the website to provide enhanced functionality and personalization.</li>
      <li><strong>Targeting Cookies:</strong> These cookies may be set through our site by our advertising partners to build a profile of your interests and show you relevant adverts on other sites.</li>
    </ul>
    <h2>Managing Cookies</h2>
    <p>
      You can control and/or delete cookies as you wish – for details, see <a href="https://www.aboutcookies.org/">aboutcookies.org</a>. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed. If you do this, however, you may have to manually adjust some preferences every time you visit a site and some services and functionalities may not work.
    </p>
    <h2>Changes to This Cookie Policy</h2>
    <p>
      We may update our Cookie Policy from time to time. We will notify you of any changes by posting the new Cookie Policy on this page. You are advised to review this Cookie Policy periodically for any changes.
    </p>
    <h2>Contact Us</h2>
    <p>
      If you have any questions about our use of cookies, please contact us at <a href="mailto:info@cysigil.com">info@cysigil.com</a>.
    </p>
  </div>
);

export default CookiePolicy;
